import axios from 'axios';

const API_KEY = '4b1cebea9a40c7eff57f5b77ee1463ff';
const API_URL = `//api.openweathermap.org/data/2.5/forecast?units=metric&appid=${API_KEY}`;

export const FETCH_WEATHER = 'FETCH_WEATHER';
export const CLEAR_WEATHER_LIST = 'CLEAR_WEATHER_LIST';
export const DELETE_WEATHER_ITEM = 'DELETE_WEATHER_ITEM';

export const fetchWeather = query => {
	const url = `${API_URL}&q=${query}`;
	const request = axios.get(url);

	return {
		type: FETCH_WEATHER,
		payload: request
	};
};

export const clearWeatherList = () => {
	return {
		type: CLEAR_WEATHER_LIST
	};
};

export const deleteWeatherItem = item => {
	return {
		type: DELETE_WEATHER_ITEM,
		payload: item
	};
};



// WEBPACK FOOTER //
// ./src/actions/index.js